import { render, staticRenderFns } from "./AnswerBlocks.vue?vue&type=template&id=55d400ce&scoped=true&lang=pug"
import script from "./AnswerBlocks.vue?vue&type=script&lang=ts"
export * from "./AnswerBlocks.vue?vue&type=script&lang=ts"
import style0 from "./AnswerBlocks.vue?vue&type=style&index=0&id=55d400ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d400ce",
  null
  
)

export default component.exports